// Which chat rooms this tab currently has open (and can write in).
//
// The server asks every socket of a message receiver, with an ack, whether
// it is in the foreground and has the message's chat open ("chat:receiver-check",
// answered in MainLayout). That ack is what decides between: no notification
// (chat open), bell only (portal open), or bell + email (not reachable).

const openRooms = new Map(); // room -> number of mounted chat views

export const chatRoomKey = (chatType, projectId) => `${chatType}_${projectId}`;

// Returns an unregister function — call it on unmount.
export function registerOpenChat(room) {
  openRooms.set(room, (openRooms.get(room) || 0) + 1);
  return () => {
    const next = (openRooms.get(room) || 0) - 1;
    if (next <= 0) openRooms.delete(room);
    else openRooms.set(room, next);
  };
}

export const isChatOpen = (room) => (openRooms.get(room) || 0) > 0;

export const isPageVisible = () => document.visibilityState === "visible";
